import { render } from "./PeopleViewer.vue?vue&type=template&id=7c537108&scoped=true"
import script from "./PeopleViewer.vue?vue&type=script&lang=js"
export * from "./PeopleViewer.vue?vue&type=script&lang=js"

import "./PeopleViewer.vue?vue&type=style&index=0&id=7c537108&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c537108"]])

export default __exports__